// Netflix-inspired sound effects URLs
export const NETFLIX_SOUNDS = {
  startup: '/netflix-sound.mp3', // Already exists
  buttonClick: 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=', // Silent fallback
  pageTransition: 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=', // Silent fallback
  navClick: 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=', // Silent fallback
};

// Sound player utility with better error handling
export const playSound = (soundUrl: string, volume: number = 0.3) => {
  try {
    const audio = new Audio(soundUrl);
    audio.volume = volume;
    audio.play().catch(error => {
      // Silently fail if sound can't play
      console.log('Sound disabled or blocked by browser');
    });
  } catch (error) {
    // Silently fail
    console.log('Sound playback not available');
  }
};

// Click sound effect (subtle)
export const playClickSound = () => {
  // Using a data URL for a very subtle click sound
  const clickSound = new Audio('data:audio/wav;base64,UklGRl4GAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YToGAACAAAAAgAAAAIAAAACAAAAAgAAAAIAAAACAAAAAgAAAAA==');
  clickSound.volume = 0.1;
  clickSound.play().catch(() => {});
};

// Transition sound effect
export const playTransitionSound = () => {
  // Using a subtle whoosh sound
  const transitionSound = new Audio('data:audio/wav;base64,UklGRl4GAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YToGAACAAAAAgAAAAIAAAACAAAAAgAAAAIAAAACAAAAAgAAAAA==');
  transitionSound.volume = 0.15;
  transitionSound.play().catch(() => {});
};